<div class="card">
    <div class="header load-enimation">
        <div class="left-header">
            <div class="circle"></div>
        </div>
        <div class="middle-header">
            <div class="big"></div>
            <div class="small"></div>
        </div>
        <div class="right-header">
            <div class="squre"></div>
        </div>
    </div>
    <div class="body">
        <div class="top-body header load-enimation"></div>
        <div class="middle-body">
            <div class="img"><img src="/assets/images/loading/loading-plus.svg" class="add-button" /></div>
        </div>
        <div class="bottom-body"></div>
    </div>
</div>